import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';
import { providesList } from './utils';
import { VehicleLocation, GeofenceEvent } from 'types';

export const trackingEndpoints = (builder: EndpointBuilder<any, any, any>) => ({
  getVehicleLocations: builder.query<VehicleLocation[], { tour?: number }>({
    query: ({ tour }) => ({
      url: `/vehicle/location/`,
      params: tour ? { tour } : undefined,
    }),
    providesTags: result => providesList(result, 'VehicleLocation'),
  }),
  getGeofenceEvents: builder.query<GeofenceEvent[], { tour?: number }>({
    query: ({ tour }) => ({
      url: `/vehicle/geofence/`,
      params: tour ? { tour } : undefined,
    }),
    providesTags: result => providesList(result, 'GeofenceEvent'),
  }),
});
